import { graphql } from '../../graphql';

export const getLocationGroups = graphql(`
  query LocationGroups($ids: [ID!], $cityId: ID) {
    locationGroups(filter: { ids: $ids }) {
      id
      name
      locations(filter: { cityId: $cityId }) {
        id
        name
        fullName
        parent {
          id
          fullName
        }
      }
    }
  }
`);
